module.exports = __webpack_public_path__ + "img/app-academy-tutor-5.ba89fdd8.png";